
import Vue from "vue";

export default Vue.extend({
  name: "OperationalLoadingDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    failed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title(): string {
      return this.failed
        ? "상점 정보를 확인하지 못했습니다"
        : "상점·수수료 정보 준비 중";
    },
    message(): string {
      return this.failed
        ? "정산 기능을 사용하려면 상점 정보를 다시 불러와야 합니다."
        : "로그인은 완료되었습니다. 상점 정보와 정산 설정을 확인하고 있습니다.";
    },
  },
});
